import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-950 text-gray-400">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">

          {/* Brand */}
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-9 h-9 flex items-center justify-center">
                <img
                  src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/b0491aed407a41b3522bccd609c14102.png"
                  alt="Hediyatik"
                  className="w-full h-full object-contain"
                />
              </div>
              <span className="text-2xl font-black font-['Playfair_Display'] text-white">Hediyatik</span>
            </div>
            <p className="text-sm leading-relaxed mb-6 text-gray-500">
              Hayatınızın özel anlarını unutulmaz el yapımı hediyelere dönüştürüyoruz. Her tasarım sizin hikayenizi anlatıyor.
            </p>
            <div className="flex gap-2">
              {[
                { href: 'https://instagram.com', icon: 'ri-instagram-line', label: 'Instagram' },
                { href: 'https://facebook.com', icon: 'ri-facebook-fill', label: 'Facebook' },
                { href: 'https://wa.me/905551234567', icon: 'ri-whatsapp-line', label: 'WhatsApp' },
                { href: 'https://pinterest.com', icon: 'ri-pinterest-fill', label: 'Pinterest' },
              ].map(s => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/5 hover:bg-orange-500 hover:text-white text-gray-500 transition-all"
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div className="md:col-span-2">
            <h4 className="text-white text-xs font-bold uppercase tracking-widest mb-5">Mağaza</h4>
            <ul className="space-y-3">
              {[
                { to: '/kategoriler', label: 'Tüm Ürünler' },
                { to: '/ozel-tasarim', label: 'Özel Tasarım' },
                { to: '/kategoriler', label: 'Çok Satanlar' },
                { to: '/kategoriler', label: 'Yeni Gelenler' },
              ].map(l => (
                <li key={l.label}>
                  <Link to={l.to} className="text-sm hover:text-orange-400 transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div className="md:col-span-3">
            <h4 className="text-white text-xs font-bold uppercase tracking-widest mb-5">Kategoriler</h4>
            <ul className="space-y-3">
              {[
                'Doğum Tasarımları',
                'Bebek Odası',
                'Aile Tasarımları',
                'Çocuk Tasarımları',
                'Dekoratif Tablolar',
                'Magnet Tasarımları',
              ].map(c => (
                <li key={c}>
                  <Link to="/kategoriler" className="text-sm hover:text-orange-400 transition-colors">{c}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-3">
            <h4 className="text-white text-xs font-bold uppercase tracking-widest mb-5">İletişim</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-orange-500 mt-0.5 shrink-0"></i>
                <span>İstanbul, Türkiye</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-orange-500 mt-0.5 shrink-0"></i>
                <a href="tel:+905551234567" className="hover:text-orange-400 transition-colors">+90 555 123 45 67</a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-orange-500 mt-0.5 shrink-0"></i>
                <a href="mailto:info@hediyatik.com" className="hover:text-orange-400 transition-colors">info@hediyatik.com</a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-time-line text-orange-500 mt-0.5 shrink-0"></i>
                <span>Pzt–Cmt: 09:00–18:00</span>
              </li>
            </ul>

            {/* Trust badges */}
            <div className="mt-6 flex flex-wrap gap-2">
              {['Güvenli Ödeme', 'Hızlı Kargo', 'İade Garantisi'].map(b => (
                <span key={b} className="inline-flex items-center gap-1 px-2.5 py-1 rounded-md bg-white/5 text-[10px] text-gray-500">
                  <i className="ri-shield-check-line text-green-500 text-xs"></i>
                  {b}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-gray-600">© 2024 Hediyatik. Tüm hakları saklıdır.</p>
          <div className="flex gap-5">
            {[
              { to: '/gizlilik', label: 'Gizlilik' },
              { to: '/kullanim-kosullari', label: 'Kullanım Koşulları' },
              { to: '/iade', label: 'İade Politikası' },
            ].map(l => (
              <Link key={l.label} to={l.to} className="text-xs text-gray-600 hover:text-orange-400 transition-colors">
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
